import React from "react";
import CustomSelect from "../common/Select";

const opcionesVinculacion = [
  { value: "12", label: "Particular" },
  { value: "01", label: "Contributivo cotizante" },
  { value: "02", label: "Contributivo beneficiario" },
  { value: "03", label: "Contributivo adicional" },
  { value: "04", label: "Subsidiado" },
  { value: "05", label: "No afiliado" },
  { value: "06", label: "Especial o Excepcion cotizante" },
  { value: "07", label: "Especial o Excepcion beneficiario" },
  { value: "08", label: "Personas privadas de la libertad a cargo del Fondo Nacional de Salud" },
  { value: "09", label: "Tomador / Amparado ARL" },
  { value: "10", label: "Tomador / Amparado SOAT" },
  { value: "11", label: "Tomador / Amparado Planes voluntarios de salud" },
  { value: "13", label: "Especial o Exepcion no cotizante Ley 352 de 1997" }
];

function SelectorVinculacion({ value, onChange, error, required = false }) {
  return (
    <CustomSelect
      options={opcionesVinculacion}
      value={value}
      onChange={onChange}
      placeholder="Seleccione..."
      label="Vinculación"
      error={error}
      required={required}
    />
  );
}

export default SelectorVinculacion;